import { InfoIconWithTooltip, SlideToggle } from "@ygtechnologies/bygr-frontend-component-library";
import PrimaryCard from "components/Statistics/PrimaryCard";
import theme from "./ProjectLicenses.module.scss";
import React from "react";
import { BygrProject, RubenProjectLicenseItemType, RubenProjectLicenseRenderedDto } from "types";
import { createRubenProjectLicense, getRubenProjectLicense, setRubenProjectLicenseItem } from "services/rubenLicense";
import { useAsyncStateWithIsLoading } from "utils/hooks";


interface ProjectLicensesRubenProps {
    project: BygrProject;
}

const ProjectLicensesRuben: React.FC<ProjectLicensesRubenProps> = (props) => {    
    const [rubenLicense, , reloadRubenLicense, isLoadingRubenLicense] = useAsyncStateWithIsLoading(() => getRubenProjectLicense(props.project.id), [props], null);

    const handleLicenseToggle = async (checked, type) => {        
        let license = rubenLicense; // This is a funcky way to handle the license, but it works.
        if (rubenLicense === null) {
            license = await createLicense();                   
        }

        if(checked){             
            await setRubenProjectLicenseItem(props.project.id, {
                projectLicenseId: license!.id,
                type: type,
                isActive: true
            })
        } else {
            await setRubenProjectLicenseItem(props.project.id, {
                projectLicenseId: license!.id,
                type: type,
                isActive: false
            })
        }
        reloadRubenLicense();
    }

    const createLicense = async (): Promise<RubenProjectLicenseRenderedDto> => {
        const newLicense = await createRubenProjectLicense(props.project.id, {
            id: 0,
            projectId: props.project.id,
            projectName: props.project.name,
            profileLicenseId: 0,
            items: []
        });        
                
        return newLicense;        
    }

    return (    
        <PrimaryCard title={'Ruben'} loading={isLoadingRubenLicense}>
            <div className={theme.licenseRows}>                                            
                <p>NOTE! Remember to activate profile license for ruben case analytics in order for users to view the analyzed cases.</p>
                <div className={theme.licenseRow}>
                    <div>Ruben case analytics</div>
                    <div className={theme.licenseTooltip}>
                        <InfoIconWithTooltip content={'This activates Ruben analytics on cases created by buyers in this project. NOTE!! This will only run the analytics job on the project. For users to see the Ruben data, the profile they belong to needs to have an active'}/>
                    </div>
                    <SlideToggle 
                        checked={rubenLicense?.items.find(x => x.type === RubenProjectLicenseItemType.CaseAnalysis)?.isActive ?? false}
                        onChange={(e) => handleLicenseToggle(e.target.checked, RubenProjectLicenseItemType.CaseAnalysis)}
                        className={theme.licenseToggle}/>
                </div>                            
                <div className={theme.licenseRow}>
                    <div>Case Inbox</div>
                    <div className={theme.licenseTooltip}>
                        <InfoIconWithTooltip content={'This activates the Case Inbox settings in the project, and gives admins access to setup and handle incoming mail. This also runs the Ruben jobs for auto creating cases from mail.'}/>
                    </div>
                    <SlideToggle 
                        checked={rubenLicense?.items.find(x => x.type === RubenProjectLicenseItemType.CaseEmail)?.isActive ?? false}
                        onChange={(e) => handleLicenseToggle(e.target.checked, RubenProjectLicenseItemType.CaseEmail)}
                        className={theme.licenseToggle}/>
                </div>
            </div>
        </PrimaryCard>        
    );
};

export default ProjectLicensesRuben;